import React from "react";
import { Container, Row, Col, Tab, Nav, Card, Button } from "react-bootstrap";

const CourseEnroll = () => {
    return (
        <Container className="my-5">
            <Row className="course-wrapper g-4">

                {/* LEFT IMAGE */}
                <Col md={8} className="course-image-wrap h-100">
                    <img
                        src="https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=600&q=80"
                        alt="Course"
                        className="course-image"
                    />
                </Col>

                {/* RIGHT INFO */}
                <Col md={4} className="course-info-wrap h-100">
                    <div className="info-row">
                        <span>Trainer’s Name</span>
                        <strong>George Mathews</strong>
                    </div>

                    <div className="info-row">
                        <span>Course Fee</span>
                        <strong>$230</strong>
                    </div>

                    <div className="info-row">
                        <span>Available Seats</span>
                        <strong>15</strong>
                    </div>

                    <div className="info-row">
                        <span>Schedule</span>
                        <strong>2.00 pm to 4.00 pm</strong>
                    </div>

                    <Button className="btn-grad border-0 btn btn-primary">
                        ENROLL THE COURSE
                    </Button>
                </Col>

            </Row>
            <Row className="g-4 mt-3 ">
                {/* LEFT CONTENT */}
                <Col lg={8}>
                    <Card className="course-box h-100">
                        <Tab.Container defaultActiveKey="description">

                            {/* BUTTON TABS */}
                            <Nav className="course-tabs mb-4">
                                <Nav.Item>
                                    <Nav.Link eventKey="description" className="tab-btn">
                                        DESCRIPTION
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="curriculum" className="tab-btn">
                                        CURRICULUM
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="reviews" className="tab-btn">
                                        REVIEWS
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Card.Body className="pt-0">
                                <Tab.Content>

                                    <Tab.Pane eventKey="description">
                                        <h6 className="fw-bold">Software Training</h6>
                                        <p className="text-muted">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                        </p>

                                        <h6 className="fw-bold mt-4">Requirements</h6>
                                        <ul className="text-muted">
                                            <li>Basic computer knowledge</li>
                                            <li>Interest in software development</li>
                                            <li>No prior coding experience required</li>
                                        </ul>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="curriculum">
                                        <p className="text-muted">Curriculum content goes here…</p>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="reviews">
                                        <p className="text-muted">Student reviews will appear here…</p>
                                    </Tab.Pane>

                                </Tab.Content>
                            </Card.Body>

                        </Tab.Container>
                    </Card>
                </Col>

                {/* RIGHT SIDEBAR */}
                <Col lg={4}>
                    <Card className="course-box h-100">
                        <Card.Body>
                            <h5 className="fw-bold mb-4">Latest Courses</h5>

                            <div className="latest-course">
                                <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80" alt="" />
                                <div>
                                    <p>How to Design a Logo a Beginner Course</p>
                                    <span className="price free">Free</span>
                                </div>
                            </div>

                            <div className="latest-course">
                                <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80" alt="" />
                                <div>
                                    <p>Photography for Beginners Masterclass</p>
                                    <span className="price">$170</span>
                                </div>
                            </div>

                            <div className="latest-course">
                                <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=600&q=80" alt="" />
                                <div>
                                    <p>The Secrets of Body Language</p>
                                    <span className="price">$220</span>
                                </div>
                            </div>

                            <Button className="w-100 mt-3 btn-grad border-0">
                                View All Courses
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CourseEnroll;
